module.exports = __webpack_public_path__ + "img/DoubleBigWheel3510Play_EGM.9c6ace01.png";